export default "__VITE_ASSET__B9W29wcG__"